import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { SharedModule } from '../../../shared.module';
import { ColumnComponent } from '../column.component';
import { type SectionColumnConfigDataValue } from '../../../../../models/enum/shared/section-column-config-data-value';
import { ColumnListLayoutModifierClass } from 'src/app/models/enum/shared/column-list-layout-types';

@Component({
  selector: 'app-column-growing-conditions',
  imports: [AsyncPipe, SharedModule],
  templateUrl: './column-growing-conditions.component.html',
  styleUrl: './column-growing-conditions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ColumnGrowingConditionsComponent extends ColumnComponent {
  constructor() {
    super();
  }

  @Input() useNgContent: boolean;
  @Input() displayFormat: SectionColumnConfigDataValue;
  @Input() columnListLayoutModifierClass: ColumnListLayoutModifierClass = null;
}
